import React, { useState } from 'react';
import { Plus, Save, X, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

export function ProductsPage({
  products,
  filteredProducts, 
  categories,
  newProduct,
  editingProduct,
  setNewProduct,
  setEditingProduct,
  addProduct,
  startEditProduct,
  saveEditedProduct,
  deleteProduct,
  addNewCategory,
}) {
  const [addingCategory, setAddingCategory] = useState(false);
  const [tempCategoryName, setTempCategoryName] = useState('');

  const handleAddCategory = () => {
    const addedCategory = addNewCategory(tempCategoryName);
    if (addedCategory) {
      setNewProduct(prev => ({
        ...prev,
        category: addedCategory,
        isNewCategory: false,
        newCategoryName: ''
      }));
      setTempCategoryName('');
      setAddingCategory(false);
    }
  };

  const handleNewCategoryChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === 'Nueva') {
      setAddingCategory(true);
    } else {
      setNewProduct({
        ...newProduct,
        category: selectedValue,
        isNewCategory: false,
        newCategoryName: ''
      });
      setAddingCategory(false);
    }
  };

  const handleEditCategoryChange = (e) => {
    const selectedValue = e.target.value;
    const isNewCategory = selectedValue === 'Nueva';
    setEditingProduct({
      ...editingProduct,
      category: selectedValue,
      isNewCategory,
      newCategoryName: isNewCategory ? '' : ''
    });
  };

  const isAddButtonDisabled = () => {
    const basicConditions = !newProduct.name.trim() || newProduct.price <= 0;
    const newCategoryCondition = addingCategory && !tempCategoryName.trim();
    return basicConditions || newCategoryCondition;
  };

  const isSaveButtonDisabled = () => {
    if (!editingProduct) return true;
    const basicConditions = !editingProduct.name.trim() || editingProduct.price <= 0;
    const newCategoryCondition = editingProduct.isNewCategory && !editingProduct.newCategoryName.trim();
    return basicConditions || newCategoryCondition;
  };

  return (
    <div className="space-y-4">
      {/* Formulario para agregar nuevo producto */}
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <h3 className="font-medium mb-3">Agregar Producto</h3>
        <div className="space-y-3">
          <Input
            placeholder="Nombre del producto"
            value={newProduct.name}
            onChange={(e) => setNewProduct({ ...newProduct, name: e.target.value })}
          />

          <Input
            type="number"
            min="0"
            step="0.01"
            placeholder="Precio"
            value={newProduct.price || ''}
            onChange={(e) => setNewProduct({
              ...newProduct,
              price: parseFloat(e.target.value) || 0
            })}
          />

          <div className="flex items-center gap-2">
            <select
              className="flex-1 px-3 py-2 border rounded-md"
              value={addingCategory ? 'Nueva' : newProduct.category}
              onChange={handleNewCategoryChange}
            >
              {categories.filter(cat => cat !== 'Todos').map(category => (
                <option key={category} value={category}>{category}</option>
              ))}
              <option value="Nueva">➕ Nueva categoría</option>
            </select>

            {addingCategory && (
              <Button
                size="sm"
                onClick={() => setAddingCategory(false)}
                variant="outline"
              >
                <X size={16} />
              </Button>
            )}
          </div>

          {addingCategory && (
            <div className="space-y-2 p-3 bg-gray-50 rounded-md">
              <div className="flex items-center gap-2">
                <Input
                  placeholder="Nombre de la nueva categoría"
                  value={tempCategoryName}
                  onChange={(e) => setTempCategoryName(e.target.value)}
                  className="flex-1"
                />
                <Button
                  onClick={handleAddCategory}
                  disabled={!tempCategoryName.trim()}
                >
                  <Plus size={16} />
                </Button>
              </div>
              {tempCategoryName.trim() && (
                <p className="text-xs text-green-600">
                  Creando categoría: {tempCategoryName}
                </p>
              )}
            </div>
          )}

          <Button
            className="w-full"
            onClick={addProduct}
            disabled={isAddButtonDisabled()}
          >
            <Plus size={18} className="mr-2" />
            Agregar Producto
          </Button>
        </div>
      </div>

      {/* Lista de productos */}
      <div className="bg-white p-4 rounded-lg shadow-sm">
       {/* <h3 className="font-medium mb-3">Lista de Productos ({products.length})</h3>
        <div className="space-y-3">
          {products.length === 0 ? (
            <p className="text-center text-gray-500 py-4">No hay productos registrados</p>
          ) : (
            products.map(product => (*/}

        <h3 className="font-medium mb-3">Lista de Productos ({products.length})</h3>
        <div className="space-y-3">
          {products.length === 0 ? (
            <p className="text-center text-gray-500 py-4">No hay productos registrados</p>
        ) : (
          filteredProducts.map(product => (
              <div key={product.id} className="border rounded-md p-3">
                {editingProduct?.id === product.id ? (
                  <div className="space-y-2">
                    <Input
                      placeholder="Nombre del producto"
                      value={editingProduct.name}
                      onChange={(e) => setEditingProduct({
                        ...editingProduct,
                        name: e.target.value
                      })}
                    />

                    <Input
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="Precio"
                      value={editingProduct.price}
                      onChange={(e) => setEditingProduct({
                        ...editingProduct,
                        price: parseFloat(e.target.value) || 0
                      })}
                    />

                    <select
                      className="w-full px-3 py-2 border rounded-md"
                      value={editingProduct.category}
                      onChange={handleEditCategoryChange}
                    >
                      {categories.filter(cat => cat !== 'Todos').map(category => (
                        <option key={category} value={category}>{category}</option>
                      ))}
                      <option value="Nueva">➕ Nueva categoría</option>
                    </select>

                    <div className="flex gap-2 mt-2">
                      <Button
                        size="sm"
                        className="flex-1"
                        onClick={saveEditedProduct}
                        disabled={isSaveButtonDisabled()}
                      >
                        <Save size={16} className="mr-1" />
                        Guardar
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        className="flex-1"
                        onClick={() => setEditingProduct(null)}
                      >
                        <X size={16} className="mr-1" />
                        Cancelar
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="font-medium">{product.name}</p>
                      <p className="text-sm text-gray-500">
                        ${product.price.toFixed(2)} - {product.category}
                      </p>
                    </div>
                    <div className="flex gap-2">
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => startEditProduct(product)}
                      >
                        <Edit size={16} />
                      </Button>
                      <Button
                        size="sm"
                        variant="destructive"
                        onClick={() => deleteProduct(product.id)}
                      >
                        <Trash2 size={16} />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
